module.exports = __webpack_public_path__ + "img/Josef Je.6719db62.jpg";